module.exports = __webpack_public_path__ + "img/Gilroy-Light.0ec07d7f.svg";